import { ContainerManifest } from '@fluidx/office-fluid-types';

export async function fetchFromCDN(manifestLocation: string): Promise<ContainerManifest | undefined> {
  let manifest: ContainerManifest | undefined;

  const queryUrl = new URL(manifestLocation);

  try {
    const response = await fetch(`${queryUrl}`, { method: 'GET' });
    if (response.ok) {
      manifest = (await response.json()) as ContainerManifest;
    }
  } catch (e) {
    // Ignore errors during fetching and/or parsing of manifest
    console.log(e);
  }

  return manifest;
}
